import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {SellerEntitiesFactory} from '../Entities/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {SellerRequestsFactory} from '../Requests/factory.js'

export class UpdateInstantOfferByIdSellerUseCase extends UseCase {
  #getCurrentUserService
  #instantOfferEntityFactory
  #instantOfferRequestFactory
  #repository

  static create = ({config}) => {
    return new UpdateInstantOfferByIdSellerUseCase({config})
  }

  constructor({config}) {
    super()

    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config})
    this.#instantOfferEntityFactory = SellerEntitiesFactory.instantOfferSellerEntity
    this.#instantOfferRequestFactory = SellerRequestsFactory.getInstantOfferSellerRequest
    this.#repository = SellerRepositoriesFactory.hTTPSellerRepository({config})
  }

  @tracer({metric: 'UpdateInstantOfferByIdSellerUseCase#execute'})
  @inlineError
  async execute({instantOfferId, plate, vehicleStatus, postalCode} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const instantOfferEntity = this.#instantOfferEntityFactory({instantOfferId})
    const instantOfferRequest = this.#instantOfferRequestFactory({
      licensePlate: plate,
      condition: vehicleStatus,
      postalCode
    })

    return this.#repository
      .updateInstantOfferById({
        instantOfferEntity,
        instantOfferRequest,
        userEntity
      })
      .then(([error]) => {
        if (error) return Promise.reject(error)
        return Promise.resolve()
      })
  }
}
